import { getFilterFormat } from "../util/dateOptions";

export interface IPayrollFilter {
  employeeIdentification: string;
  documentID: string;
  payrollType: number;
  processState: number;
  issueDateFrom: Date | null;
  issueDateTo: Date | null;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}

export interface IPayrollTrace {
  trackId: string;
  action: string;
  actionDate: string;
  observations: IPayrollTraceObservation[];
}

export interface IPayrollTraceObservation {
  code: string;
  message: string;
}

export interface IPayrollFilterResponse {
  payrollList: IPayrollList[] | null;
  length: number;
}

export interface IEmployeesAutocomplete {
  identification: string;
  name: string;
}

export interface IPayrollList {
  id: string;
  payrollType: string;
  documentID: string;
  documentValue: number;
  totalRevenues: number;
  totalDiscounts: number;
  createdOn: string;
  modifiedOn: string;
  issueDate: string;
  employeeIdentification: string;
  employeeName: string;
  resultCode: number;
  resultCodeMessage: string;
  cune: string;
  isValid: boolean;
}

export interface IPayrollDetail {
  id: string;
  payrollType: string;
  documentID: string;
  documentValue: number;
  totalRevenues: number;
  totalDiscounts: number;
  createdOn: string;
  modifiedOn: string;
  issueDate: string;
  formatedValue: string;
  employeeIdentification: string;
  employeeName: string;
  resultCode: number;
  resultCodeMessage: string;
  cune: string;
  qrData: string;
  isValid: boolean;
  supplierlogo: string;
  suppliername: string;
}

export interface IResendPayrollMailForm {
  contact: string;
  mail: string;
  subject?: string;
  ccEmail?: string;
}

export const getPayrollFilter = (filter: IPayrollFilter, pageSize: number, page: number) => {
  return {
    pageSize: pageSize,
    page: page,
    employeeIdentification: filter.employeeIdentification,
    documentID: filter.documentID,
    payrollType: filter.payrollType,
    processState: filter.processState,
    issueDateFrom: getFilterFormat(filter.issueDateFrom),
    issueDateTo: getFilterFormat(filter.issueDateTo),
    sortBy: filter.sortBy,
    sortDirection: filter.sortDirection,
  };
};
